import React, { useMemo, useState, useEffect } from 'react'
import { FaBook, FaThumbsUp, FaThumbsDown, FaRegIdCard, FaBuilding, FaAddressCard, FaSpinner } from 'react-icons/fa'
import { Wrapper, BarStrip, ProgressBar, TextFieldIcon, SelectFieldIcon } from '../_components'
import Table from '../_components/Table'
import data from '../fixtures'
import Axios from 'axios'
import moment from 'moment'
import { Formik } from 'formik'
import { Bar } from 'react-chartjs-2';
import { values } from 'lodash'

const steps = [
  "Pending", "Actioned"
]

const ActionField = ( record ) => {
    return (

        <div onClick={async () => {
            try {
                const file_id = record.value;
                const email = btoa(localStorage.getItem( "email" )); // Base64 encode
                const url = process.env.REACT_APP_API_URL+`/api/auth/get_file_details/${file_id}/${email}`
                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                if (newWindow) newWindow.opener = null
            } catch (error) {}
        } } className="cursor-pointer w-auto md:w-20 lg:w-24 py-1 rounded bg-[#AFC836] text-xs text-black flex items-center justify-center">
            {`View`}
        </div>
    )
}

export default function AllSignedCertificates( ) {

    const columns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Company",
        accessor: "applicant"
        },
        {
        Header: "Certificate No.",
        accessor: "certificate_number"
        },
        {
        Header: "Issued On",
        accessor: "date"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
        }
    ])

    const notSignedColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Applicant",
        accessor: "applicant"
        },
        {
        Header: "Stage",
        accessor: "stage"
        },
        {
        Header: "Annual Income",
        accessor: "annual_income"
        },
        {
        Header: "ISIC Codes",
        accessor: "isic_codes"
        },
        {
        Header: "Applied On",
        accessor: "date"
        },
        {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
        }
    ])

    const expiryColumns = useMemo( () => [
        {
        Header: "#",
        accessor: "recordId"
        },
        {
        Header: "Email",
        accessor: "email_address"
        },
        {
        Header: "Applicant",
        accessor: "applicant"
        },
        {
        Header: "Annual Income",
        accessor: "annual_income"
        },
        {
        Header: "ISIC Codes",
        accessor: "isic_codes"
        },
        {
        Header: "Date of Expiry",
        accessor: "date"
        },
        {
        Header: "Action",
        accessor: "id",
        Cell: ActionField
        }
    ])
    
    const [ auditReportRecords, setAuditReportRecords ] = useState( [] )
    const [ records, setRecords ] = useState( [] )
    const [ certLevelStartDate, setCertLevelStartDate ] = useState( [] )
    const [ certLevelEndDate, setCertLevelEndDate ] = useState( [] )
    const [ expiringRecords, setExpiringRecords ] = useState( [] )
    const [ paidButNotSignedrecords, setPaidButNotSignedrecords ] = useState( [] )
    const [ loading, setLoading ] = useState( true )
    const [ searchLoading, setSearchLoading ] = useState( false )

    React.useEffect( () => {
        if( loading ) {
            fetchApplications()
            fetchPaidButNotSignedApplications()
        }
    },[ loading ])

    const fetchApplications = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/getAllSignedCertificates` ) 

            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        applicant: result.trading_name,
                        certificate_number: result.certificate_serial_number,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.applicant,
                        date: moment( result.issued_on ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } )
                console.log(response.data)

                //update the state
                setRecords( results )
                setLoading( false )
            }
        } catch (error) {
            console.log(error)
            alert( "Server error occurred." )
            setLoading( false )
        }
    }

    const fetchPaidButNotSignedApplications = async () => {
        try {
            const response = await Axios.get( process.env.REACT_APP_API_URL+`/api/auth/paid_but_not_signed` ) 

            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        applicant: result.trading_name,
                        stage: showStage(result.stage),
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.applicant,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } )
                console.log(response.data)

                //update the state
                setPaidButNotSignedrecords( results )
                setLoading( false )
            }
        } catch (error) {
            console.log(error)
            alert( "Server error occurred." )
            setLoading( false )
        }
    }

    const showStage  = (stage_number) => {
        switch(stage_number){
            case "1":
                return "VERIFICATION";
            case "2":
                return "FINANCE";
            case "3":
                return "AUDITOR";
            case "4":
                return "AUDITOR";
            case "5":
                return "LEVEL 1";
            case "6":
                return "LEVEL 2";
            case "7":
                return "LEVEL 3";
            case "8":
                return "APPROVAL";
            case "9":
                return "APPROVED";
            default:
              return
        }
    }

    const downloadSignedCertificatesList = async () => {
        try {
            const url = process.env.REACT_APP_API_URL+`/api/auth/signed_certificates_search_pdf/`+certLevelStartDate+`/`+certLevelEndDate
            const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
            if (newWindow) newWindow.opener = null
        } catch (error) {}
    }

    const handleReportsSearch = async (values) => {
        setSearchLoading( true )
        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/getAllSignedCertificates`, {
                from_date: values.from_date,
                to_date: values.to_date,
            })

            setCertLevelStartDate(values.from_date)
            setCertLevelEndDate(values.to_date)
    
            if( response.data.success === true ) {
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        applicant: result.trading_name,
                        certificate_number: result.certificate_serial_number,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.applicant,
                        date: moment( result.created_at ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } )
                console.log(response.data)
                console.log("search is done")

                //update the state
                setRecords( results )
                setLoading( false )
            }
        } catch (error) {
            console.log(error)
        } finally {
            setSearchLoading( false )
        }
    }

    const handleExpiredCertificatesSearch = async (values) => {

        try {
            const response = await Axios.post( process.env.REACT_APP_API_URL+`/api/auth/certificates_about_to_expire`, {
                time_period: values.time_period,
            })
    
            if( response.data.success === true ) {
                console.log("returned expired certificates below")
                console.log(response.data.records)
                const results = response.data.records.map( ( result, index ) => {
                    return {
                        recordId: `${index+1}`,
                        applicant: result.trading_name,
                        annual_income: result.annual_turnover,
                        isic_codes: result.service_name,
                        email_address: result.created_by,
                        date: moment( result.certificate_expiry_date ).format( "DD MMM, YYYY" ),
                        id: result.id
                    }
                } )
                console.log(response.data)
                console.log("search for certiticates about to expire is done")

                //update the state
                setExpiringRecords( results )
                setLoading( false )
            } else{
                console.log("search for expired not successful")
            }
        } catch (error) {
            console.log("There was an error trying to search for expired certificates")
            console.log(error)
        }
    }

    if( localStorage.getItem( "link" ) === "all_signed_certificates" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Signed Certificates Report`}
                        </div>
    
                        <div className="flex flex-col justify-center w-full bg-white">
                            <Formik initialValues={{
                                from_date: values.from_date,
                                to_date: values.to_date,
    
                                }} onSubmit={handleReportsSearch}>
                                { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                        return (
                                            <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                                <div className="flex row px-5">
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="from_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.from_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="From"
                                                            required={true}
                                                            disabled={false}
                                                            question="From" 
                                                        />
                                                    </div>
    
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="to_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.to_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="To"
                                                            required={true}
                                                            disabled={false}
                                                            question="To" 
                                                        />
                                                    </div>
    
                                                    <div className="basis-1/4 pt-2">
                                                        <div className="w-full pt-6 grid grid-cols-1">
                                                            <button 
                                                                className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm flex items-center justify-center" 
                                                                type="submit" 
                                                                name="submit"
                                                                disabled={searchLoading}
                                                            >
                                                                {searchLoading ? (
                                                                    <>
                                                                        <FaSpinner className="animate-spin mr-2" />
                                                                        Loading...
                                                                    </>
                                                                ) : (
                                                                    'Submit'
                                                                )}
                                                            </button>
                                                        </div>
                                                        {/* <SelectFieldIcon 
                                                            name="application_id"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.application_id}
                                                            iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                            label="Search Application"
                                                            required={false}
                                                            disabled={false}
                                                            options={applicationsDropdown.map( ( { id, label, value } ) => {
                                                                return { id, label, value }
                                                            } )}
                                                            question="Search Application" 
                                                        /> */}
                                                    </div>
    
                                                    <div className="basis-1/4">
                                                        
                                                    </div>                                                    
                                                </div>
                                            </form>
                                        )
                                    }  }
                            </Formik>

                            <a onClick={async () => {
                                downloadSignedCertificatesList()
                            } } className="cursor-pointer text-xs text-blue-600 curser-pointer">
                                {` Dowload List`}
                            </a>
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={columns}
                            data={records}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    if( localStorage.getItem( "link" ) === "paid_but_not_signed" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Paid applicants who have not yet been certified`}
                        <a onClick={async () => {
                            try {
                                const url = process.env.REACT_APP_API_URL+`/api/auth/paid_but_not_signed_print`
                                const newWindow = window.open(url, '_blank', 'noopener,noreferrer')
                                if (newWindow) newWindow.opener = null
                            } catch (error) {}
                        } } className='cursor-pointer ml-10 text-blue-400 font-normal'>Click to view PDF</a>
                        </div>
    
                        <div className="flex flex-col justify-center w-full bg-white">
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="My Reports"
                            columns={notSignedColumns}
                            data={paidButNotSignedrecords}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }

    if( localStorage.getItem( "link" ) === "about_to_expire" ) {
        return (
            <Wrapper>
                <div className="flex flex-col h-full">
                    <div className="flex-grow flex flex-col bg-gray-100 my-2 px-5">
                        <div className="px-5 py-2 text-sm bg-white text-[#AFC836] font-bold text-lg">
                        {`Certificates About To Expire`}
                        </div>
    
                        <div className="flex flex-col justify-center w-full bg-white">
                            <Formik initialValues={{
                                from_date: values.from_date,
                                to_date: values.to_date,
    
                                }} onSubmit={handleExpiredCertificatesSearch}>
                                { ( { handleSubmit, handleBlur, handleChange, values } ) => {
                                        return (
                                            <form className="my-2 bg-white" onSubmit={handleSubmit}>
                                                <div className="flex row px-5">
                                                    <div className="basis-1/4">
                                                        <SelectFieldIcon 
                                                        spaced
                                                        name="time_period"
                                                        handleChange={evt => {
                                                            handleChange(evt)
                                                        }}
                                                        handleBlur={handleBlur}
                                                        value={values.time_period}
                                                        iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                        label="Time Period"
                                                        options={[ 
                                                            { id: 1, value: "0", label: "Today" },
                                                            { id: 2, value: "2", label: "In 2 Weeks" },
                                                            { id: 3, value: "3", label: "In 3 Weeks" },
                                                            { id: 4, value: "4", label: "In 4 Weeks" },
                                                            { id: 5, value: "5", label: "In 3 Months" }
                                                        ]}
                                                        question="Time Period" />
                                                    </div>

                                                    {/* <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="from_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.from_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="From"
                                                            required={true}
                                                            disabled={false}
                                                            question="From" 
                                                        />
                                                    </div>
    
                                                    <div className="basis-1/4">
                                                        <TextFieldIcon 
                                                            type="date"
                                                            name="to_date"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.to_date}
                                                            iconComponent={<FaAddressCard color={`#AFC836`} />} 
                                                            label="To"
                                                            required={true}
                                                            disabled={false}
                                                            question="To" 
                                                        />
                                                    </div> */}
    
                                                    <div className="basis-1/4 pt-4">
                                                        <div className="w-full pt-6 grid grid-cols-1">
                                                            <button className="bg-cyan-500 px-2 py-1 mx-2 text-sm text-white rounded-sm" type="submit" name="submit">Submit</button>
                                                        </div>
                                                        {/* <SelectFieldIcon 
                                                            name="application_id"
                                                            handleChange={handleChange}
                                                            handleBlur={handleBlur}
                                                            value={values.application_id}
                                                            iconComponent={<FaBuilding color={`#AFC836`} />} 
                                                            label="Search Application"
                                                            required={false}
                                                            disabled={false}
                                                            options={applicationsDropdown.map( ( { id, label, value } ) => {
                                                                return { id, label, value }
                                                            } )}
                                                            question="Search Application" 
                                                        /> */}
                                                    </div>
    
                                                    <div className="basis-1/4">
                                                        
                                                    </div>                                                    
                                                </div>
                                            </form>
                                        )
                                    }  }
                            </Formik>
                        
                            <Table 
                            rightButton={false}
                            rightBtnCallback={ () => {}}
                            rightButtonLabel={null}
                            label="Certificates about to expire"
                            columns={expiryColumns}
                            data={expiringRecords}
                            hidePagination={false}
                            exportToExcel={() => {}}
                            exportToCSV={() => {}}
                            />
                        </div>
                    </div>
                </div>
            </Wrapper>
        )
    }
}